var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backTop"},[_c('a-back-top',{attrs:{"visibilityHeight":320}},[_c('svg-icon',{attrs:{"icon":"backTop"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }